<div id="cookieContainer" tabindex="1" class="cookies-banner align-items-center justify-content-center" *ngIf="showCookiesBanner">
    <div>
        {{'FOC._COMMON_ACROSS_PAGES.COOKIES_BANNER.WEBSITE_USES_COOKIES' | translate}}
        <a tabindex="1" qid="cookies-1" (click)="navigateToPrivacyLink()" href="javascript:void(0);" class="privacy-policy-btn">{{'FOC._COMMON_ACROSS_PAGES.COOKIES_BANNER.PRIVACY_POLICY' | translate}}.</a>
    </div>
    <div class="ml-3 ml-sm-4">
        <a tabindex="1" qid="cookies-2" href="javascript:void(0);" class="btn btn-white-bg accept-btn" (click)="acceptCookies()">{{'FOC._COMMON_ACROSS_PAGES.COOKIES_BANNER.ACCEPT' | translate}}</a>
    </div>
</div>
<div class="app-container" [ngClass]="{'cookiesBannerVisible': showCookiesBanner}">
    <router-outlet></router-outlet>
</div>
<app-close-modal ></app-close-modal>
<app-asset-error-modal></app-asset-error-modal>
<autoupdate-error-modal></autoupdate-error-modal>
<downloading-error-modal></downloading-error-modal>